export default "<h6 *ngIf=\"title\"><small>{{title}}</small></h6>\n<div #mapWrapper id=\"map\" style=\"height:300px; width:100%\"></div>"